import {
    MANAGER_PROFILE_FAIL,
    MANAGER_PROFILE_SUCCESS,
    MANAGER_PROFILE_REQUEST, MANAGER_UPDATE_SUCCESS, MANAGER_NOTIFICATION_SUCCESS, LOGIN_ACTION, MANAGER_NOTIFY_SUCCESS
} from '../actions/manager.js';


const initialState = {
    userStatus: 'request',
    employee: {},
    notification:{},
    token:'',
    notify:0,
    accountantArray: [],
};
// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case MANAGER_PROFILE_REQUEST: {
            return {
                ...state,
                userStatus: 'request',
            };
        }
        case LOGIN_ACTION: {
            return {
                ...state,
                token: action.payload.token,
            };
        }
        case MANAGER_UPDATE_SUCCESS:
        {
            return {
                ...state,
                userStatus: 'ok',
                employee:action.payload.data
            };
        }
        case MANAGER_PROFILE_SUCCESS: {
            console.log(action.payload.data.manager? action.payload.data.manager : action.payload.data);
            
            return {
                ...state,
                userStatus: 'ok',
                employee:action.payload.data.manager? action.payload.data.manager : action.payload.data,
                accountantArray:action.payload.data.accountant_ids || []
            };
        }
        case MANAGER_NOTIFICATION_SUCCESS: {
            return {
                ...state,
                notification:action.payload.data
            };
        }
        case MANAGER_NOTIFY_SUCCESS: {
            return {
                ...state,
                notify:action.payload.data.count
            };
        }
        case MANAGER_PROFILE_FAIL: {
            return {
                ...state,
                userStatus: 'fail',
            };
        }



        default: {
            return {
                ...state,
            };
        }
    }
}
